import { DateUtil } from '@ddt-web/generic-utils';
import { UrlUtils } from '@ddt-web/url';

export class AssetPathUtil {
	public static getAssetPath(cacheBusterMinutes: number, publicFilePath: string, publicFilePathPreview: string): string {
		let rootPath = window['ASSET_PREFIX_PATH'] ?? '/blk-one-c-assets';
		let fileName = publicFilePath;
		if (UrlUtils.isLocalhost()) {
			return '/assets/public-models.json';
		} else if (UrlUtils.isTestCloud()) {
			rootPath = 'https://testc.blackrock.com/blk-one-c-assets';
		} else if (UrlUtils.isPreview()) {
			fileName = publicFilePathPreview;
			rootPath = 'https://preview.blackrock.com/blk-one-c-assets';
		} else if (UrlUtils.isInternalHost() || UrlUtils.isProdDmz()) {
			rootPath = 'https://www.blackrock.com/blk-one-c-assets';
		}

		const cacheBusterId = DateUtil.roundTimeToNearestMinutes(cacheBusterMinutes);
		const assetPath = rootPath + '/cache-' + cacheBusterId + fileName;
		const fullPath = UrlUtils.removeDuplicateSlashes(assetPath);
		return fullPath;
	}
}
